import React from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import SigninRedirect from "../pages/SigninRedirect";
import SimulatedAccess from "../pages/SimulatedAccess";
import Routes from "../Routes";
import "../fonts/Roboto-Medium.ttf";
import "../fonts/Roboto-Regular.ttf";
import "./style.css";

function App() {
  return (
    <BrowserRouter>
      <Switch>
        <Route exact component={SigninRedirect} path="/signin-redirect" />
        <Route exact component={SimulatedAccess} path="/acesso-simulado" />
        <Routes />
      </Switch>
    </BrowserRouter>
  );
}

export default App;
